import {
    FETCH_NOTIFICATION_DATA_SUCCESS,
    RESET_NOTIFICATION_DATA_SUCCESS,
    UPDATE_NOTIFICATION_PANEL_SETTING_DATA_SUCCESS,
    UPDATE_NOTIFICATION_DATA_SUCCESS,
    CHANGE_GROUP_UPDATES_SUCCESS,
    RESET_WORKKARD_GROUP_SUCCESS,
    CHANGE_ACTIVITY_UPDATES_SUCCESS,
    FETCH_NOTIFICATION_DETAIL_DATA_SUCCESS,
    RESET_NOTIFICATION_DETAIL,
    RESET_GROUPING_DATA,
    GET_AU_COUNT_SUCESS,
    MARK_ALL_READ,
    MARK_ALL_GROUP_READ,
    HIDE_HEADER_LOADER,
    SHOW_HEADER_LOADER,
    UPDATE_NOTIFICATION_DETAIL_DATA_SUCCESS,
    UPDATE_NOTIFICATION_COUNTER,
    UPDATE_NEW_NOTIFICATION_DETAIL_DATA,
    RESET_NOTIFICATION_REQUEST
    // UPDATE_GROUP_NOTIFICATION_COUNTER_SUCCESS
} from "../actions/actionConstants";
import {mergeArrayByKey} from "../../../common/util";
import {status as filterStatus} from "../Notification/constants";

const initialState = {
    isLoading:false,
    auCount:{},
    groupingData:{},
    filter:{filterStatus:null},
    notificationDetail:{},
    panelFilterSettings:{},
    newNotificationCount: 0
};

const mapNotificationModel = (data) => data.map((item) => {
    let keys = Object.keys(item);
    keys.map(key=>{
        item[key.charAt(0).toUpperCase() + key.slice(1)] = item[key]; 
        delete item[key]; 
    })
    return item;
  });
  

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_NOTIFICATION_DATA_SUCCESS:
            let panelSetting={IsGroupByEnabled:action.payload.panelFilterSettings.IsGroupByEnabled};
            let filter=(action.payload.panelFilterSettings.Data) ? {filterStatus:action.payload.panelFilterSettings.Data} : state.filter;
            let responseData=Object.assign(action.payload.data,{sortOrder:action.payload.sortOrder});
            let newState={ groupingData: responseData, panelFilterSettings: panelSetting,filter: filter}
            return Object.assign({}, state, newState);

        case UPDATE_NOTIFICATION_PANEL_SETTING_DATA_SUCCESS:
            return Object.assign({}, state, {filter: action.payload});
        
        case RESET_NOTIFICATION_DATA_SUCCESS:
            const newUpdate=Object.assign({}, state.groupingData, {Data: []});
            const newDetail=Object.assign({}, state.notificationDetail, {Data: []});
            return Object.assign({}, state, {groupingData: newUpdate,notificationDetail:newDetail})
        
        case UPDATE_NOTIFICATION_DATA_SUCCESS:
            const grpData=state.groupingData.Data;
            const newGrpData=action.payload.Data; 
            const mergedNewGrpData=state.panelFilterSettings.IsGroupByEnabled ? mergeArrayByKey(grpData,newGrpData,'WorkkardId') : mergeArrayByKey(grpData,newGrpData,'Id');
            const newLatesGrpUpdate=Object.assign({},state.groupingData,{Data:mergedNewGrpData});  
            return Object.assign({},state,{groupingData:newLatesGrpUpdate});
            
        case UPDATE_NOTIFICATION_DETAIL_DATA_SUCCESS:
            const data=state.notificationDetail.Data ;
            const newData = action.payload.Data; 
            const mergedNewData=mergeArrayByKey(data,newData,'Id');
            const newLatesUpdate=Object.assign({},state.notificationDetail,{Data:mergedNewData});  
            return Object.assign({},state,{notificationDetail:newLatesUpdate});

        case UPDATE_NEW_NOTIFICATION_DETAIL_DATA:
            const newau = [action.payload.Data];
            const updatedDetailData = mergeArrayByKey(mapNotificationModel(newau), state.notificationDetail.Data, 'Id');
            return Object.assign({}, state, { notificationDetail: Object.assign({}, state.notificationDetail, { Data: updatedDetailData }) });

        case CHANGE_GROUP_UPDATES_SUCCESS:
            const unreadCount = action.payload;
            const newObj = Object.assign({},state.groupingData,{UnreadNotificationCount:unreadCount});
            return Object.assign({},state,{groupingData:newObj});

        case RESET_WORKKARD_GROUP_SUCCESS:
            const { wkId, notificationId, fltStatus, UnreadNotificationCount}=action.payload;
            let id=(wkId==0 ? null : wkId);
            let filterData = [];
            if(state.filter.filterStatus != filterStatus.all){
                filterData = state.panelFilterSettings.IsGroupByEnabled ?
                            state.groupingData.Data.filter(item => (item['RecentNotification'].WorkkardId || item['RecentNotification'].WorkkardId) != id) 
                            :  
                            state.groupingData.Data.filter(item => (item.WorkkardId || item.WorkkardId) != id);
                const dataUpdate=Object.assign({},state.groupingData,{Data:filterData});  
                const detailFilterData = Object.keys(state.notificationDetail).length > 0 && state.notificationDetail.Data.length > 0 ? state.notificationDetail.Data.filter(item => item.WorkkardId != id) : [];
                const detailUpdate=Object.assign({},state.notificationDetail,{Data:detailFilterData});
                return Object.assign({},state,{groupingData:dataUpdate,notificationDetail:detailUpdate});
            }
            else{
                let resetgroupstatusdata = Object.assign({},
                    state,
                    {
                        groupingData: Object.assign(
                            {},
                            state.groupingData,
                            {
                                Data: state.groupingData.Data.map((data) => {
                                    if (data['RecentNotification'].Id == notificationId) {
                                        return Object.assign({}, data, { RecentNotification: Object.assign({}, data['RecentNotification'], { Status: fltStatus }), GroupNotificationCounter: 0, UnreadNotificationCount: UnreadNotificationCount} )
                                    }
                                    return data;
                                })
                            }
                        )
                    }
                )
                return Object.assign({},state,resetgroupstatusdata);
            }

        case CHANGE_ACTIVITY_UPDATES_SUCCESS:
            const {activityUpdateIds,Id,status} = action.payload;
            let filterActivityData=[];
            if(state.filter.filterStatus != filterStatus.all ){
                filterActivityData = (Object.keys(state.groupingData).length >0 && state.groupingData.Data.length >0) ? 
                                        (state.panelFilterSettings.IsGroupByEnabled ? 
                                            state.groupingData.Data.filter(item => item['RecentNotification'].Id != activityUpdateIds) 
                                            : 
                                            state.groupingData.Data.filter(item => item.Id != activityUpdateIds))
                                        : [];
                const activityDataUpdate=Object.assign({},state.groupingData,{Data:filterActivityData});  

                const notificationDetailFilterData=Object.keys(state.notificationDetail).length > 0 && state.notificationDetail.Data.length > 0 && 
                        state.notificationDetail.Data.filter(item => item.Id != activityUpdateIds);
                const detailDataUpdate=Object.assign({},state.notificationDetail,{Data:notificationDetailFilterData});

                return Object.assign({},state,{groupingData:activityDataUpdate,notificationDetail:detailDataUpdate});
            }
            else{
                let notificationDetailState ,groupingState={};
                if(Object.keys(state.notificationDetail).length >0 && state.notificationDetail.Data.length >0){
                    notificationDetailState = Object.assign({},
                        state,
                        {
                            notificationDetail: Object.assign(
                                {},
                                state.notificationDetail,
                                {
                                    Data: state.notificationDetail.Data.map((data) => {
                                        if (data.Id == Id) {
                                            return Object.assign({}, data, { Status: status })
                                        }
                                        return data;
                                    })
                                }
                            )
                        }
                    )
                }
                else if(Object.keys(state.groupingData).length >0 && state.groupingData.Data.length >0){
                    groupingState = Object.assign({},
                        state,
                        {
                            groupingData: Object.assign(
                                {},
                                state.groupingData,
                                {
                                    Data: state.groupingData.Data.map((data) => {
                                        if (data.Id == Id) {
                                            return Object.assign({}, data, { Status: status })
                                        }
                                        return data;
                                    })
                                }
                            )
                        }
                    )
                }

                return Object.assign({}, state, groupingState, notificationDetailState);
            }


        case FETCH_NOTIFICATION_DETAIL_DATA_SUCCESS:
            return Object.assign({}, state, {notificationDetail: action.payload});

        case RESET_NOTIFICATION_DETAIL:
            return Object.assign({}, state, {notificationDetail: {}});
        
        case RESET_GROUPING_DATA:
            return Object.assign({}, state, {groupingData: {}});

        case GET_AU_COUNT_SUCESS:
            return Object.assign({}, state, { newNotificationCount:action.payload.Data });
        
        case MARK_ALL_GROUP_READ:
            const {grpfilterStatus }=action.payload;

            if(state.filter.filterStatus != filterStatus.all ){
                let resetData= {};

                if(Object.keys(state.notificationDetail).length >0 && state.notificationDetail.Data.length > 0) 
                {
                    resetData=Object.assign({}, state.notificationDetail, {Data: []});
                    return Object.assign({}, state, {notificationDetail: resetData});
                }
                else
                {
                    resetData=Object.assign({}, state.groupingData, {Data: []})
                    return Object.assign({}, state, {groupingData: resetData});
                }
                
            }
            else{
                const markAllAsGrpReadUpdateData=
                (Object.keys(state.notificationDetail).length > 0 && state.notificationDetail.Data.length >0) ?
                (
                    Object.assign({},
                        state,
                        {
                            notificationDetail: Object.assign(
                                {},
                                state.notificationDetail,
                                {
                                    Data: state.notificationDetail.Data.map((data) => {
                                        return Object.assign({}, data, { Status: grpfilterStatus })
                                    })
                                }
                            )
                        }
                    )
                )
                :
                (
                    Object.assign({},
                        state,
                        {
                            groupingData: Object.assign(
                                {},
                                state.groupingData,
                                {
                                    Data: state.groupingData.Data.map((data) => {
                                        return Object.assign({}, data, { Status: grpfilterStatus })
                                    })
                                }
                            )
                        }
                    )
                )
                
                return Object.assign({}, state, markAllAsGrpReadUpdateData);
            }
        case MARK_ALL_READ:
            const { allFilterStatus, allUpdates }=action.payload;

            if(state.filter.filterStatus != filterStatus.all ){
                const resetData=Object.assign({}, state.groupingData, {Data: []});
                return Object.assign({}, state, {groupingData: resetData});
            }
            else{
                const markAllAsReadUpdateData=Object.assign({},
                    state,
                    {
                        groupingData: Object.assign(
                            {},
                            state.groupingData,
                            {
                                Data: state.groupingData.Data.map((data) => {
                                    if(allUpdates && state.panelFilterSettings.IsGroupByEnabled){
                                        return Object.assign({}, data, { RecentNotification: Object.assign({}, data['RecentNotification'], { Status: allFilterStatus }) }, { UnreadNotificationCount: 0, GroupNotificationCounter: 0, RecentWorkkardCountRecieved: false } )
                                    }else{
                                        return Object.assign({}, data, { Status: allFilterStatus })
                                    }
                                })
                            }
                        )
                    }
                )
                return Object.assign({}, state, markAllAsReadUpdateData);
            }

        case HIDE_HEADER_LOADER:
            return Object.assign({}, state, {isLoading: false})
        case SHOW_HEADER_LOADER:
            return Object.assign({}, state, {isLoading: true})
        case UPDATE_NOTIFICATION_COUNTER:
            return Object.assign({}, state, { newNotificationCount: action.payload })

        case RESET_NOTIFICATION_REQUEST:
            return Object.assign({},initialState);

        // case UPDATE_GROUP_NOTIFICATION_COUNTER_SUCCESS:
        //     const notificationData=action.payload;

        //     const updatedNotificationData=Object.assign({},
        //         state,
        //         {
        //             groupingData: Object.assign(
        //                 {},
        //                 state.groupingData,
        //                 {
        //                     Data: state.groupingData.Data.map((data) => {
        //                         const filterWrkd=notificationData.filter(item=>item.WorkkardId==data.WorkkardId);
        //                         if (filterWrkd.WorkkardId == data.WorkkardId) {
        //                             return Object.assign({}, data, { RecentNotification: Object.assign({}, data['RecentNotification'] , { GroupNotificationCounter: filterWrkd.GroupNotificationCounter } )} )
        //                         }
        //                         return data;
        //                     })
        //                 }
        //             )
        //         }
        //     )
        //     return Object.assign({}, state, updatedNotificationData);
        default:
            return state;
    }
}